<app-generic-form [title]="isEditing() ? 'Modifica Profilo' : 'Profilo'" [wide]="true">
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" id="userForm" form-content>
    <div class="row g-4">

      <!-- Colonna Sinistra: Dati Principali -->
      <div class="col-12 col-lg-6 d-flex">
        <div class="w-100 d-flex flex-column gap-3">
          <h3 class="h5 fw-bold mb-3">Dati principali</h3>

          <div>
            <label for="email" class="form-label">Email</label>
            <input
              id="email"
              formControlName="email"
              type="email"
              class="form-control"
              [class.is-invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched">
            @if (isGoogleUser() && isEditing()) {
              <div class="form-text text-muted">
                <i class="bi bi-info-circle me-1" aria-hidden="true"></i>Non puoi modificare l'email perché hai effettuato l'accesso con Google.
              </div>
            }
            @if (userForm.get('email')?.invalid && userForm.get('email')?.touched) {
              <div class="invalid-feedback">Inserisci un'email valida.</div>
            }
          </div>

          <div>
            <label for="username" class="form-label">Username</label>
            <input
              id="username"
              formControlName="username"
              type="text"
              class="form-control"
              [class.is-invalid]="userForm.get('username')?.invalid && userForm.get('username')?.touched">
            @if (userForm.get('username')?.invalid && userForm.get('username')?.touched) {
              <div class="invalid-feedback">Lo username è obbligatorio.</div>
            }
          </div>

          @if (isAssociation()) {
            <div>
              <label for="website" class="form-label">Sito Web</label>
              <input
                id="website"
                formControlName="website"
                type="text"
                class="form-control">
            </div>

            <div>
              <label for="city" class="form-label">Città</label>
              <input
                id="city"
                formControlName="city"
                type="text"
                class="form-control">
            </div>

            <div>
              <label for="vatNumber" class="form-label">Partita IVA</label>
              <input
                id="vatNumber"
                formControlName="vatNumber"
                type="text"
                class="form-control">
            </div>
          }
        </div>
      </div>

      <!-- Colonna Destra: Dati Profilo -->
      <div class="col-12 col-lg-6 d-flex">
        <div class="w-100 d-flex flex-column gap-3">
          <h3 class="h5 fw-bold mb-3">Dati del giocatore</h3>

          <div class="flex-grow-1 d-flex flex-column">
            <label for="bio" class="form-label">Bio</label>
            <textarea
              id="bio"
              formControlName="bio"
              class="form-control flex-grow-1"
              style="min-height: 100px;"
              rows="4"></textarea>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div form-actions class="w-100">
    @if (isEditing()) {
      <div class="d-grid gap-3 d-md-flex">
        <button
          type="button"
          class="btn btn-secondary flex-fill"
          (click)="onCancel()">
          <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Indietro
        </button>

        <button
          type="submit"
          form="userForm"
          class="btn btn-primary flex-fill"
          [disabled]="userForm.invalid || isLoading()">
          <i class="bi" [class.bi-hourglass-split]="isLoading()" [class.bi-check-lg]="!isLoading()" aria-hidden="true"></i>
          <span class="ms-1">{{ isLoading() ? 'Salvataggio...' : 'Salva' }}</span>
        </button>
      </div>
    } @else {
      <ng-content select="[view-actions]"></ng-content>
    }
  </div>
</app-generic-form>
